import React, { useEffect, useState } from 'react';
import '@assets/fonts/styles.css';
import '@assets/css/style.css';
import avatar from '@assets/default-avatar/9.png';
import { useAuth } from '@hooks/use-auth';
import { useSelector } from 'react-redux';
import { useModal, MODAL_TYPES } from '@contexts/global-modal-context';
import { useDispatch } from 'react-redux';
import { toggleMenu } from '@reducers/menu-reducer';
import { SUCCESSFUL } from '@models/status';
import { Stats } from '@models/partner.model';
import { useTranslation } from 'react-i18next';
import { RootState } from '@redux/store';
import { useToast } from '@hooks/use-toast';
import { useSideBar } from '@hooks/use-sidebar';
import { SidebarType } from '@enums/sidebar.enum';
// Notice here we're using the function declaration with the interface Props
const ProfileSidebar: React.FunctionComponent = () => {
    const { setSideBar } = useSideBar();
    const { t } = useTranslation(['sidebar']);
    const { user, logout } = useAuth();
    const { opened } = useSelector((state: RootState) => state.menuStore);
    const { status, data } = useSelector((state: any) => state.partnerStore);
    const [referersNumbers, setReferersNumber] = useState<number>(0);
    const [activeReferersNumbers, setActiveReferersNumber] = useState<number>(0);
    const toast = useToast();
    const dispatch = useDispatch();
    const { showModal } = useModal();
    const updateProfile = () => {
        dispatch(toggleMenu());
        showModal(MODAL_TYPES.UPDATE_PROFILE_MODAL, {});
    };

    const handleLogout = () => {
        dispatch(toggleMenu());
        logout();
        toast?.success('Vous êtes maintenant déconnecté.');
    };

    const handleReferral = () => {
        dispatch(toggleMenu());
        showModal(MODAL_TYPES.REFERRAL_MODAL, {});
    };

    useEffect(() => {
        if (status === SUCCESSFUL) {
            setReferersNumber(data[Stats.REFERERS].value);
            setActiveReferersNumber(data[Stats.ACIVE_REFEERS].value);
        }
    }, [status]);

    if (!user) {
        return null;
    }

    const handleOpenMenu = () => {
        dispatch(toggleMenu());
    };

    return (
        <div className={`left-side ${opened ? 'open' : ''}`}>
            <button className="close-sub-menu web-hide" onClick={handleOpenMenu}>
                <span className="icon icon12">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M15.7071 1.70711C16.0976 1.31658 16.0976 0.683417 15.7071 0.292893C15.3166 -0.0976311 14.6834 -0.0976311 14.2929 0.292893L15.7071 1.70711ZM0.292893 14.2929C-0.0976311 14.6834 -0.0976311 15.3166 0.292893 15.7071C0.683417 16.0976 1.31658 16.0976 1.70711 15.7071L0.292893 14.2929ZM1.70712 0.292893C1.3166 -0.0976311 0.683432 -0.0976311 0.292907 0.292893C-0.097617 0.683418 -0.097617 1.31658 0.292907 1.70711L1.70712 0.292893ZM14.2929 15.7071C14.6834 16.0976 15.3166 16.0976 15.7071 15.7071C16.0977 15.3166 16.0977 14.6834 15.7071 14.2929L14.2929 15.7071ZM14.2929 0.292893L0.292893 14.2929L1.70711 15.7071L15.7071 1.70711L14.2929 0.292893ZM0.292907 1.70711L14.2929 15.7071L15.7071 14.2929L1.70712 0.292893L0.292907 1.70711Z"
                            fill="white"
                        />
                    </svg>
                </span>
            </button>
            <div className="sub-menu">
                <div className="top-menu">
                    <a onClick={() => setSideBar(SidebarType.DASHBOARD)} className="button return">
                        <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M6.5 1.5L1.5 6.5L6.5 11.5"
                                stroke="white"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                        {t("Retourner à l'acceuil")}
                    </a>
                    <div className="toggle-switch">
                        <label>
                            <input type="checkbox" />
                            <span className="slider">
                                <span className="dark icon12 icon">
                                    <svg
                                        width="14"
                                        height="14"
                                        viewBox="0 0 14 14"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M1 10.3333L1.19934 9.3534C0.800488 9.27227 0.392254 9.44097 0.167037 9.78001C-0.0581808 10.119 -0.0554377 10.5608 0.173973 10.897L1 10.3333ZM6.33333 1L6.35961 0.00034529C5.95169 -0.0103768 5.57818 0.227825 5.41586 0.602207C5.25354 0.976589 5.33497 1.41204 5.62161 1.70246L6.33333 1ZM13.3333 7C13.3333 3.17329 10.2093 0.101533 6.35961 0.00034529L6.30706 1.99965C9.12501 2.07372 11.3333 4.30869 11.3333 7H13.3333ZM6.33333 14C10.3089 14 13.3333 10.8559 13.3333 7H11.3333C11.3333 9.7728 9.18291 12 6.33333 12V14ZM0.173973 10.897C1.48441 12.8175 3.88325 14 6.33333 14V12C4.47823 12 2.72809 11.0917 1.82603 9.7697L0.173973 10.897ZM0.800657 11.3133C3.93807 11.9515 6.61811 10.31 7.94212 8.0093C9.26931 5.70306 9.30986 2.59218 7.04505 0.297535L5.62161 1.70246C7.1454 3.24632 7.16995 5.34132 6.20867 7.01173C5.2442 8.68767 3.36329 9.7936 1.19934 9.3534L0.800657 11.3133Z"
                                            fill="#212121"
                                        />
                                    </svg>
                                </span>
                                <span className="light icon icon12">
                                    <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M2 7.25C1.58579 7.25 1.25 7.58579 1.25 8C1.25 8.41421 1.58579 8.75 2 8.75V7.25ZM3.33333 8.75C3.74755 8.75 4.08333 8.41421 4.08333 8C4.08333 7.58579 3.74755 7.25 3.33333 7.25V8.75ZM2.80304 12.1363C2.51015 12.4292 2.51015 12.9041 2.80304 13.197C3.09594 13.4899 3.57081 13.4899 3.8637 13.197L2.80304 12.1363ZM5.19704 11.8637C5.48993 11.5708 5.48993 11.0959 5.19704 10.803C4.90414 10.5101 4.42927 10.5101 4.13638 10.803L5.19704 11.8637ZM8.75 12.6667C8.75 12.2525 8.41421 11.9167 8 11.9167C7.58579 11.9167 7.25 12.2525 7.25 12.6667H8.75ZM7.25 14C7.25 14.4142 7.58579 14.75 8 14.75C8.41421 14.75 8.75 14.4142 8.75 14H7.25ZM11.8637 10.803C11.5708 10.5101 11.0959 10.5101 10.803 10.803C10.5101 11.0959 10.5101 11.5708 10.803 11.8637L11.8637 10.803ZM12.1363 13.197C12.4292 13.4899 12.9041 13.4899 13.197 13.197C13.4899 12.9041 13.4899 12.4292 13.197 12.1363L12.1363 13.197ZM3.86366 2.803C3.57077 2.51011 3.0959 2.51011 2.803 2.803C2.51011 3.0959 2.51011 3.57077 2.803 3.86366L3.86366 2.803ZM4.13634 5.197C4.42923 5.48989 4.9041 5.48989 5.197 5.197C5.48989 4.9041 5.48989 4.42923 5.197 4.13634L4.13634 5.197ZM12.6667 7.25C12.2525 7.25 11.9167 7.58579 11.9167 8C11.9167 8.41421 12.2525 8.75 12.6667 8.75V7.25ZM14 8.75C14.4142 8.75 14.75 8.41421 14.75 8C14.75 7.58579 14.4142 7.25 14 7.25V8.75ZM10.803 4.13634C10.5101 4.42923 10.5101 4.9041 10.803 5.197C11.0959 5.48989 11.5707 5.48989 11.8636 5.197L10.803 4.13634ZM13.197 3.86366C13.4899 3.57077 13.4899 3.0959 13.197 2.803C12.9041 2.51011 12.4292 2.51011 12.1363 2.803L13.197 3.86366ZM8.75 2C8.75 1.58579 8.41421 1.25 8 1.25C7.58579 1.25 7.25 1.58579 7.25 2H8.75ZM7.25 3.33333C7.25 3.74755 7.58579 4.08333 8 4.08333C8.41421 4.08333 8.75 3.74755 8.75 3.33333H7.25ZM9.25 8C9.25 8.69036 8.69036 9.25 8 9.25V10.75C9.51878 10.75 10.75 9.51878 10.75 8H9.25ZM8 9.25C7.30964 9.25 6.75 8.69036 6.75 8H5.25C5.25 9.51878 6.48122 10.75 8 10.75V9.25ZM6.75 8C6.75 7.30964 7.30964 6.75 8 6.75V5.25C6.48122 5.25 5.25 6.48122 5.25 8H6.75ZM8 6.75C8.69036 6.75 9.25 7.30964 9.25 8H10.75C10.75 6.48122 9.51878 5.25 8 5.25V6.75ZM2 8.75H3.33333V7.25H2V8.75ZM3.8637 13.197L5.19704 11.8637L4.13638 10.803L2.80304 12.1363L3.8637 13.197ZM7.25 12.6667V14H8.75V12.6667H7.25ZM10.803 11.8637L12.1363 13.197L13.197 12.1363L11.8637 10.803L10.803 11.8637ZM2.803 3.86366L4.13634 5.197L5.197 4.13634L3.86366 2.803L2.803 3.86366ZM12.6667 8.75H14V7.25H12.6667V8.75ZM11.8636 5.197L13.197 3.86366L12.1363 2.803L10.803 4.13634L11.8636 5.197ZM7.25 2V3.33333H8.75V2H7.25Z"
                                            fill="white"
                                        />
                                    </svg>
                                </span>
                            </span>
                        </label>
                    </div>
                </div>
                <div className="user-profile">
                    <div className="user-avatar">
                        <img src={avatar} alt="" />
                    </div>
                    <div className="user-id">
                        <span className="user-name">@{user.pseudo}</span>
                        {/* <span className="user-pseudo">@{user.pseudo}</span> */}
                        <div className="sub-infos">
                            <span className="user-folower">
                                {referersNumbers} {t('Filleuls')}
                            </span>
                            <span className="user-sold">
                                {activeReferersNumbers} {t('Filleuls actifs')}
                            </span>
                        </div>
                    </div>
                </div>
                <div className="user-datas">
                    <div className="user-line">
                        <div className="line-label">{t('Votre porte-monnaie')}</div>
                        <div className="line-value">
                            <span className="data">{t('Votre solde principale')}</span>
                            <span className="value money">
                                {user.balance} <span className="currency">XAF</span>
                            </span>
                        </div>
                        <div className="line-value">
                            <span className="data"> {t('Votre solde bonus')} </span>
                            <span className="value money">
                                {user.bonus} <span className="currency">XAF</span>
                            </span>
                        </div>
                    </div>
                    <div className="user-line">
                        <div className="line-label">{t("Données d'identification")}</div>
                        <div className="line-value">
                            <span className="data"> {t('Date de naissance')} </span>
                            <span className="value">---</span>
                        </div>
                        <div className="line-value">
                            <span className="data"> {t('Localisation')} </span>
                            <span className="value"> ---</span>
                        </div>
                        <div className="line-value">
                            <span className="data">
                                Tel. principal
                                <span className={`verification ${user.verified ? '' : 'danger'}`}>
                                    {user.verified ? t('verified') : t('un_verified')}
                                </span>
                            </span>
                            <span className="value">
                                {user.phone_number || user.pending_phone_change?.phone_number}
                            </span>
                        </div>
                        <div className="line-value">
                            <span className="data">E-mail</span>
                            <span className="value">---</span>
                        </div>
                    </div>
                </div>
                <div className="text-center w-100">
                    <button className="default opaced w-100" onClick={updateProfile}>
                        {t('Editer mon profil')}
                    </button>
                    <button className="default opaced w-100 mt-1 mb-1" onClick={handleReferral}>
                        {t('Parainage')}
                    </button>
                    <button className="danger w-100 text-center" type="button" onClick={handleLogout}>
                        {t('Déconnexion')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ProfileSidebar;
